// extracted by mini-css-extract-plugin
export var amount = "styles-module--amount--ae2c8";
export var button = "styles-module--button--023eb";
export var container = "styles-module--container--af80d";
export var content = "styles-module--content--03ce0";
export var description = "styles-module--description--d4ede";
export var firstTitle = "styles-module--firstTitle--8df07";
export var freebet = "styles-module--freebet--4cade";
export var image = "styles-module--image--b7c7f";
export var imageMobile = "styles-module--imageMobile--2dc43";
export var images = "styles-module--images--addad";
export var ru = "styles-module--ru--913b9";
export var rulesLink = "styles-module--rulesLink--811e0";
export var secondTitle = "styles-module--secondTitle--43281";
export var text = "styles-module--text--3a9ca";
export var title = "styles-module--title--f38f4";